module.exports = __webpack_public_path__ + "static/media/dashboardimprove.c56cafe0.png";